module.exports = __webpack_public_path__ + "ADN-Modos.ea34a88deebef937bb4d.png";


//////////////////
// WEBPACK FOOTER
// /mnt/c/Dev/CoolDevs/modos/app/src/assets/Inicio/ADN-Modos.png
// module id = ../../../../../src/assets/Inicio/ADN-Modos.png
// module chunks = styles